export default __webpack_public_path__ + "static/3-eaee28380af0c0f16a0dc9ac28d3ba8c.png";